import { useCallback, useEffect, useState } from "react";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { useParams } from "react-router-dom";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { IFaturaDTO } from "../../../types/pagamento";
import { Pagamento } from "../../../services/Pagamento";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

export const useConfirmAppointment = () => {
  const params = useParams();
  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO
  );
  const [fatura, setFatura] = useState<IFaturaDTO>({} as IFaturaDTO);
  const { setIsLoad } = useContextSite();

  function handleDownload() {
    Agendamento.downloadRecibo({ uuidAgendamento: agendamento.uuid })
      .then()
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }

  const getFatura = useCallback(() => {
    Pagamento.consultarFatura({ uuidAgendamento: params.uuidAgendamento })
      .then(({ data }) => {
        const value = data?.content?.find(
          (f) => f.status === StatusPagamentoEnum.pending || f.status === StatusPagamentoEnum.paid
        );
        setFatura(value);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }, []);

  useEffect(() => {
    if (params?.uuidAgendamento) {
      setIsLoad(true);
      Agendamento.getById({ uuid: params?.uuidAgendamento })
        .then(({ data }) => setAgendamento(data))
        .catch(
          ({
            response: {
              data: { mensagem },
            },
          }) => toast.error(mensagem)
        )
        .finally(() => setIsLoad(false));
      getFatura();
    }
  }, [params]);

  return { agendamento, handleDownload, fatura };
};
